import { render, staticRenderFns } from "./Buyers.vue?vue&type=template&id=4e207dd9&scoped=true"
import script from "./Buyers.vue?vue&type=script&lang=ts"
export * from "./Buyers.vue?vue&type=script&lang=ts"
import style0 from "./Buyers.vue?vue&type=style&index=0&id=4e207dd9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e207dd9",
  null
  
)

export default component.exports